/* eslint-disable import/no-unresolved */
import { isEmpty } from 'lodash';
import { SELECT_FUND } from 'common/constants/funds';
import { CustomSelect, withTooltip } from 'components';
import { useFeatureSpreadsheet } from 'components/FeaturedSpreadsheet/context/FeaturedSpreadsheetContext';
import { useFundOwnershipContext } from 'context/FundOwnershipContext';
import { toString } from 'utilities';
import FundEntityListProps from './FundEntityList.props';

const FundEntityList = ({ cell, ...restProps }: FundEntityListProps) => {
  const { onCommit, onRevert } = restProps;
  const { onCellsChanged } = useFeatureSpreadsheet();
  const { fundEntityListValues } = useFundOwnershipContext();

  const handleChange = (value: string | null) => {
    const newValue = value !== null ? toString(value) : '';
    onCellsChanged([{ cell, value: newValue }]);
  };

  if (!cell.columnLegend || isEmpty(fundEntityListValues[cell.columnLegend])) {
    return <div>No funds available</div>;
  }

  return (
    <CustomSelect
      autoFocus
      disabled={cell.readOnly}
      id={`security-list-${cell.key}`}
      menuPosition="bottom"
      onChange={handleChange}
      onCommit={(value: string | null) => onCommit?.(value ?? '')}
      onEmptyValue={SELECT_FUND}
      onRevert={onRevert}
      openMenuOnFocus
      options={fundEntityListValues[cell.columnLegend!]}
      value={cell.value as string}
    />
  );
};

export default withTooltip(FundEntityList);
